export default function ResultRow({children, style = {}, ...props}) {
    return (
        <tr {...props} style={{...style}}>
            {children}
        </tr>
    )
}